import { useContext } from 'react'
import type { UsePreferencesResult } from './hooks/usePreferences'
import { PreferencesContext } from './preferencesContextValue'

export function usePreferencesContext(): UsePreferencesResult {
  const ctx = useContext(PreferencesContext)
  if (!ctx) {
    throw new Error('usePreferencesContext must be used within <PreferencesProvider>')
  }
  return ctx
}
